<template>
  <div class="unit-subgroup-outer">
    <template v-if="containers && containers.length && show">
      <div class="unit-subgroup">
        <div class="unit-subgroup__head">
          <div class="row d-flex align-items-center">
            <div class="unit-subgroup__head-left">
              <div class="unit-subgroup__code" v-if="code">{{code}}</div>
              <div class="unit-subgroup__title">{{title}}</div>
            </div>
            <div class="unit-subgroup__head-right">

              <div class="unit-subgroup__head-alert"
                :class="[ credits > 0 && credits < requiredCredits ? 'warning' : '', credits > 0 && credits > requiredCredits ? 'danger' : '' ]">
                <span v-if="credits > 0 && credits < requiredCredits"><i class="far fa-exclamation-circle">
                  </i>Select {{ requiredCredits - credits }} more points
                </span>
                <span v-if="credits > 0 && credits > requiredCredits">
                  <i class="far fa-exclamation-circle"></i>Too many units selected
                </span>
                <span class="unit-subgroup__credits">{{ credits }} / {{ requiredCredits }} credit points</span>
              </div>
              <!--<button type="button" class="btn-icon unit-subgroup__delete" @click="remove">
                <i class="far fa-trash-alt"></i>
              </button>-->
            </div>
          </div>
          <div class="unit-subgroup__head-description" v-if="description" v-html="description"></div>
        </div>
        <div class="unit-subgroup__body">
          <template v-for="(con,index) in containers">
            <UnitGroupCategory
              :container="con" :location="getContainerLocation(con)" :key="index" :canAdd="canAdd"
              :autoSelectMandatory="con.connector==='AND' && mandatory" :firstLevelContainer="firstLevelContainer" />
          </template>
        </div>
      </div>
    </template>
    <template v-if="relationships && relationships.length && show">
      <UnitGroupCategory :container="container" :location="location" :firstLevelContainer="firstLevelContainer" />
    </template>
  </div>
</template>

<script>
import UnitCard from './UnitCard.vue'
import { mapGetters, mapActions } from 'vuex'
import { dynamicSort } from 'common/helpers/dynamic-sort.js'
import SelectionLocationHelper from 'client/js/utils/selection-location-helper.js'

export default {
  props: {
    container: {
      type: Object,
      required: false
    },
    relationship: {
      type: Object,
      required: false
    },
    location: {
      type: String,
      required: true
    },
    canAdd: {
      type: Boolean,
      required: false,
      default: false
    },
    virtualRelationship: {
      type: Boolean,
      required: false,
      default: false
    },
    parentLocation: {
      type: String,
      required: false
    },
    firstLevelContainer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedItemsByLocation: 'units/getSelectedCurriculumItemByLocation',
      totalCredits: 'units/getTotalCredits'
    }),
    containers() {
      if (this.container) {
        return this.container.container.slice().sort(dynamicSort('order'))
      } else if (this.structure) {
        return this.structure.containers.slice().sort(dynamicSort('order'))
      } else {
        return []
      }
    },
    credits() {
      return this.totalCredits(this.location, true)
    },
    relationships() {
      return this.container ? this.container.relationship.slice().sort(dynamicSort('order')) : []
    },
    structure: function () {
      if (this.relationship) {
        return this.relationship.structure
      }
      return null
    },
    selectedItems() {
      return this.selectedItemsByLocation(this.location) || []
    },
    selectedItemsInContainer: (container) => {
      return this.selectedItemsByLocation(this.getContainerLocation(container)) || []
    },
    show() {
      return this.selectedItems.length > 0
    },
    title() {
      return this.container ? this.container.title : this.relationship ? this.relationship.name : ''
    },
    requiredCredits() {
      const credits = this.container ? this.container.credits : this.relationship ? this.relationship.credits : ''
      return parseInt(credits)
    },
    code() {
      return this.relationship ? this.relationship.code : ''
    },
    mandatory() {
      return this.container ? this.container.connector === 'AND' : this.relationship ? this.relationship.connector === 'AND' : false
    },
    hasEnoughCredits() {
      return this.credits >= this.requiredCredits
    },
    hasChildren() {
      return this.relationships.length || this.containers.length
    },
    description() {
      if (this.container && this.container.description.length) {
        return this.container.description
      } else if (this.relationship && this.relationship.description.length) {
        return this.relationship.description
      }
      return false
    }
  },
  methods: {
    ...mapActions({
      detachStructure: 'courses/detachStructure',

      removeItem: 'units/removeCurriculumItem',
      removeRelationships: 'units/removeRelationships',
    }),
    getContainerLocation(container) {
      if (!container) {
        return ''
      }
      return SelectionLocationHelper.getContainerLocation(this.location, container)
    },
    remove() {
      if (this.show) {
        this.selectedItems.forEach((item) => {
          this.removeItem({
            location: item.location,
            relationship: item.relationship,
            recursive: false
          })
        })

        if (this.relationship && this.virtualRelationship) {
          this.removeRelationships({
            location: this.parentLocation,
            relationships: [this.relationship]
          })
        }

        this.detachStructure(this.location)
      }
    }
  },
  mounted() {},
  beforeDestroy() {},
  components: { UnitGroupCategory: () => import('./UnitGroupCategory.vue'), UnitCard }
}
</script>
